module.exports = __webpack_public_path__ + "img/img2-en.950228e2.png";